// extracted by mini-css-extract-plugin
export default {"container":"project_container__ktbNV","links":"project_links__y2t4q"};